














































import VueOptions from '@utils/VueOptions'
import VenueNavbar from '@ui/VenueWizard/VenueNavbar'
import WizardNavigation from '@ui/VenueWizard/WizardNavigation'
import FormField from '@ui/FormBuilder/FormField'

settings =
  name: 'VenueOverviewStep'

  resources:
    teams:
      resourceName: 'suppliers'
      slug: 'suppliers/:wizard.supplierId/suppliers'

  vue:
    props: ['wizard', 'step']

    components: {
      VenueNavbar,
      WizardNavigation,
      FormField,
    }

    data: ->
      form: @wizard.venueData

    computed:
      inputPropsForTeamSelect: ->
        options: @teams
        context:
          supplierId: @wizard.supplierId

export default VueOptions.vue settings
